import { useCurrentIncident } from '../hooks/commonHooks';
import React from 'react';
import MemberStatusControls from './MemberStatusControls';
import UserIncidentPositions from './UserIncidentPositions';

const IncidentProfile: React.FC = () => {
  const { data: incident } = useCurrentIncident();

  return (
    <div className="maincontent p-2">
      <div className="p-2">
        <h4 className="m-0">{incident?.name ?? 'Incident'} Profile</h4>
      </div>
      <div className="p-2">
        <MemberStatusControls />
        <div className="mt-4">
          <UserIncidentPositions />
        </div>
      </div>
    </div>
  );
};
export default IncidentProfile;
